<!-- eslint-disable vuejs-accessibility/form-control-has-label -->
<!-- eslint-disable vuejs-accessibility/label-has-for -->
<!-- eslint-disable vuejs-accessibility/iframe-has-title -->
<template>
  <div
    :class="[
      'subscription flex flex-row flex-wrap items-center gap-x-[76px] text-[14px]',
      { 'lg:flex-nowrap': noWrap },
    ]"
  >
    <div class="flex flex-col">
      <!-- Title -->
      <h2 class="subscription__title">
        {{ $i18n('blog.subscription-title') }}
      </h2>
      <!-- ./Title -->

      <!-- Description -->
      <div class="subscription__description">
        <span>{{ $i18n('blog.subscription-description') }}</span>
      </div>
      <!-- ./Description -->
    </div>
    <div
      v-show="subscriptionSuccess !== null"
      :id="subscriptionSuccess ? 'success-message' : 'error-message'"
      class="sib-form-message-panel__text sib-form-message-panel__text--center"
    >
      {{ $i18n(subscriptionMessage) }}
    </div>
    <div v-if="subscriptionSuccess !== true" class="subscription__input">
      <div id="sib-form-container">
        <div id="sib-container">
          <iframe id="dummyframe" name="dummyframe" style="display: none" />
          <form id="sib-form" method="POST" target="dummyframe" action="">
            <div class="subscription__input">
              <input
                id="EMAIL"
                v-model="emailValue"
                class="subscription__input-email"
                type="email"
                name="EMAIL"
                autocomplete="off"
                :placeholder="$i18n('blog.email-address')"
                data-required="true"
                required
              />
              <label
                class="entry__error entry__error--primary"
                style="
                  font-size: 16px;
                  text-align: left;
                  font-family: 'Helvetica', sans-serif;
                  color: #661d1d;
                  background-color: #ffeded;
                  border-radius: 3px;
                  border-color: #ff4949;
                "
              />
              <button
                :aria-label="$i18n('blog.subscribe')"
                class="sib-form-block__button-with-loader subscription__input__subscribe-button"
                form="sib-form"
                type="submit"
                @click="subscribe"
              >
                <svg class="icon clickable__icon progress-indicator__icon sib-hide-loader-icon" viewBox="0 0 512 512">
                  <path
                    d="M460.116 373.846l-20.823-12.022c-5.541-3.199-7.54-10.159-4.663-15.874 30.137-59.886 28.343-131.652-5.386-189.946-33.641-58.394-94.896-95.833-161.827-99.676C261.028 55.961 256 50.751 256 44.352V20.309c0-6.904 5.808-12.337 12.703-11.982 83.556 4.306 160.163 50.864 202.11 123.677 42.063 72.696 44.079 162.316 6.031 236.832-3.14 6.148-10.75 8.461-16.728 5.01z"
                  />
                </svg>
                {{ $i18n('blog.subscribe') }}
              </button>
            </div>
            <!-- Subscription agreement -->
            <div class="subscription__agreement">
              <p v-html="$i18n('blog.subscription-agreement')"></p>
            </div>
            <!-- ./Subscription agreement -->
            <input type="text" hidden name="email_address_check" value="" />
            <input type="hidden" name="locale" value="en" />
            <input type="hidden" name="html_type" value="simple" />
          </form>
        </div>
      </div>
    </div>
    <!-- ./Subscription Input -->
  </div>
</template>
<script>
export default {
  name: 'EmailSubscription',
  props: {
    noWrap: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      emailValue: null,
      subscriptionMessage: null,
      subscriptionSuccess: null,
    };
  },
  head: {
    link: [
      {
        rel: 'stylesheet',
        href: 'https://sibforms.com/forms/end-form/build/sib-styles.css',
      },
    ],
  },
  methods: {
    subscribe() {
      if (this.emailValue) {
        const request = this.$store.dispatch('subscribeToNewsLetter', {
          emailaddress: this.emailValue,
          host: this.$paths.host,
        });
        request.then((response) => {
          this.subscriptionSuccess = response.success;
          this.subscriptionMessage = response.message;
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.subscription {
  &__title {
    @apply font-cocogoose text-[20px] md:text-[28px] mb-[10px] leading-[1.32];
  }

  &__description {
    @apply mb-[10px];
  }
  &__agreement {
    @apply mt-[10px] text-[13px];
    p {
      contain: inline-size;
    }
  }
  &__input {
    @apply relative flex w-full max-w-[500px];

    &-email {
      @apply border w-full h-[50px] rounded-[6px] border-[#e5e7eb] px-5 outline-none focus:ring-1 focus:ring-orange-600 duration-200;
      box-shadow:
        0 6px 10px 0 rgba(3, 4, 8, 0.04),
        0 1px 2px 0 rgba(13, 16, 22, 0.06);
    }

    &__subscribe-button {
      @apply duration-200 h-full absolute top-0 right-0 py-[10px] px-[20px] font-cocogoose text-[16px] text-white bg-orange-600 rounded-r-[6px] border border-orange-600 hover:bg-orange-700 outline-none leading-relative;
    }
  }
}
#sib-form,
#sib-container,
#sib-form-container {
  @apply w-full block bg-transparent pl-0 pr-0;
}
#success-message {
  @apply text-left bg-[#e8f5e5] border border-[#20a200] rounded-md max-w-full w-full;
}
#error-message {
  @apply text-left bg-[#a81900]/10 border border-[#d92001] rounded-md max-w-full w-full;
}
.subscription__agreement p > a {
  @apply cursor-pointer text-blue-500;
}
</style>
